<template>
<div class="stories">
  <BContainer class="stories-container">
    <BRow>
      <BCol :lg="10" :sm="12">
        <InfoPanel
          v-for="p in filteredNews"
          :key="p.uid"
          :include-image="false"
          :link="p.route"
          class="story-panel">
          <h2>{{ p.label }}</h2>
          <p class="describe">
            {{ p.description }}
          </p>
          <!-- <ConsultingIcon -->
          <!--   class="story-icon" -->
          <!--   :width="200" -->
          <!--   :height="200" -->
          <!--   slot="image"/> -->

        </InfoPanel>
      </BCol>
      <BCol
        :lg="2"
        :sm="12">
        <div class="header">
          <!-- <input type="search" v-model="searchString"/> -->
          <div
            class="tags">
            <h2>Topics</h2>
            <a
              v-for="t in tags"
              :key="t"
              @click="toggleTagActive(t)"
              class="tag"
              :class="{ active: activeTags.includes(t) }">
              {{ t }}
            </a>
          </div>
        </div>
      </BCol>
    </BRow>
  </BContainer>
</div>
</template>

<script>
import InfoPanel from '@/components/sections/InfoPanel';
import ScrollIntoView from '@/mixins/ScrollIntoView';
import ConsultingIcon from '@/assets/img/reports1.svg';
import { mapGetters } from 'vuex'
import {
  BContainer,
  BRow,
  BCol,
} from 'bootstrap-vue'


export default {
  name: 'Stories',
  mixins: [
    ScrollIntoView,
  ],
  props: {},
  data() {
    return {
      searchString: null
      //  tagFilter: ["code","R"]
    };
  },
  components: {
    InfoPanel,
    'b-container': BContainer,
    'b-row': BRow,
    'b-col': BCol,
    ConsultingIcon
  },
  created() {},
  watch: {},
  computed: {
    ...mapGetters([
      'activeNews',
      'currentDate',
    ]),
    activeTags(){
      // return filter from address
      const tags = this.$route.query.tags||'';
      console.log('tags', tags)
      return tags === '' ? [] : tags.split(',');
    },
    tags(){
      const tags = this.activeNews.map( d => d.tags||[]);
      return new Set([].concat(...tags));
    },
    filteredNews(){
      if(this.activeTags.length === 0 && !this.searchString) return this.activeNews;
      return this.activeNews
        .filter(d => this.searchFilter(d) && this.tagFilter(d.tags));
    }
  },
  methods: {
    tagFilter(tags){
      return this.activeTags.length === 0 || tags.some(t => this.activeTags.includes(t))
    },
    searchFilter(d){
      return !this.searchString || d.label.toLowerCase().indexOf(this.searchString) > -1
    },
    toggleTagActive(tag){
      const tags = this.activeTags.includes(tag)
            ? this.activeTags.filter(d => d!==tag)
            : [...this.activeTags, tag];
      const query = tags.length
            ? { tags: tags.join(',') }
            : {}
      this.$router.push({ query })

    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';
.stories  {

  .tags {
    //margin-left: 1rem;
    .tag {
      @include tag;
    }
  }

  .stories-container {
    max-width: 60rem;
    margin: 1rem auto;

    .row {
      flex-wrap: wrap-reverse;
    }

    .header {
      //display: flex;
      //flex-direction: row;
      //align-items: center;
    }
  }
}
</style>
